module.exports = __webpack_public_path__ + "a64d8c4dad2a125adab932ef79f78d5a.png";